export default __webpack_public_path__ + "static/char-08-anr-8817df23e7f8630bcb4ef8470b99a942.webp";